import Vue from 'vue';
import VueI18n from 'vue-i18n';
import _defaults from 'lodash/defaults';
import cookie from '@/helpers/cookie';

Vue.use(VueI18n);

function getCurrentLocale(existingLocales = []) {
  const cookieLocal = cookie.getLocaleFromCookie();
  if (existingLocales.includes(cookieLocal)) {
    return cookieLocal;
  }

  const browserLocal = window.navigator.languages
    .find((locale) => existingLocales.includes(locale));
  if (browserLocal) {
    return browserLocal;
  }

  return existingLocales[0];
}

function loadLocaleMessages() {
  const appLocales = process.env.VUE_APP_I18N_LOCALE;
  const locales = require.context('./locales', false, /[A-Za-z0-9-_,\s]+\.json$/i);
  const overrideLocales = require.context(`./locales/${process.env.VUE_APP_FM_MODE}`, false, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      if (appLocales.includes(locale)) {
        try {
          messages[locale] = _defaults(overrideLocales(key), locales(key));
        } catch (e) {
          messages[locale] = locales(key);
        }
      }
    }
  });
  return messages;
}

const messages = loadLocaleMessages();
const existingLocales = Object.keys(messages);
const currentLocale = getCurrentLocale(existingLocales);

cookie.setLocaleInCookieOnYear(currentLocale);

export default new VueI18n({
  locale: currentLocale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
  messages: loadLocaleMessages(),
});
